import doc                         from '@widesk-core/decorators/doc';
import AbstractSitePageStatusModel from './AbstractSitePageStatusModel';
import model                       from '@widesk-core/decorators/model';

@doc.urnResource('site_page_status')
@model.cacheDuration()
export default class SitePageStatusModel extends AbstractSitePageStatusModel {
	get color() {
		switch (this.reference) {
			case 'ENABLED':
				return 'green';
			case 'DISABLED':
				return 'red';
		}
	}
}
